import { LifestyleConfirmPageTemplateProps } from "./template";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "@auth";
import { useCreateLifestyleGroup } from "@mutations";
import { CurrencyTypes, PartnerLSAGroupInputParams } from "@api";
import { LSACategory } from "../../../../types";
//import { lifestyleCategories } from "../categories/categories-data";

export const useLifestyleConfirmPage = (): LifestyleConfirmPageTemplateProps => {
    const navigate = useNavigate();
    const location = useLocation();
    const { lifestyleCategories, isLoadingData } = useContext(AuthContext);
    const createLifestyleGroup = useCreateLifestyleGroup();
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Need to make sure that all of the data has properly been passed from the previous pages
    
    // Get data from navigation state
    const { selectedCategories = [], lifestyleGroupName = "", rules = {} } = location.state || {};
    const { yearlyAmount = 1000, coveragePercentage = 80, allocationType = 'pro-rata' } = rules;

    const navigateToPage = (to: string) => {
        navigate(to);
    }

    const onReturnPressed = () => {
        // Pass data back to rules page
        navigate("/dashboard/lifestyle/rules", {
            state: {
                selectedCategories,
                lifestyleGroupName,
                rules: {
                    yearlyAmount,
                    coveragePercentage,
                    allocationType
                }
            }
        });
    }

    const onConfirm = () => {
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
    }

    const onConfirmCreate = async () => {
        const group: PartnerLSAGroupInputParams = {
            name: lifestyleGroupName,
            yearlySpendingLimit: yearlyAmount,
            currency: CurrencyTypes.CAD,
            prorated: allocationType === "pro-rata",
            startDate: new Date().toISOString(),
            resetDate: new Date().toISOString(),
            runOffPeriod: 30,
            coveragePercentage: coveragePercentage
        }

        const categoriesForMutation = selectedCategories
            .filter((category: LSACategory) => category.id && category.id.trim() !== '')
            .map((category: LSACategory) => ({
                id: category.id,
                name: category.name,
                description: category.description,
                examples: category.examples || [],
                icon: category.icon || ''
            }));

        await createLifestyleGroup(group, categoriesForMutation);
        
        navigate("/dashboard/lifestyle/complete");
    }

    // Map selected category titles to their icon and title data
    const selectedCategoriesData = selectedCategories.map((selectedCategory: LSACategory) => {
        const category = lifestyleCategories?.find(
            (cat) => cat.id === selectedCategory.id || cat.name === selectedCategory.name
        );
        return {
            icon: category?.icon || selectedCategory.icon || "📊",
            title: category?.name || selectedCategory.name || ""
        };
    });

    return {
        navigateToPage,
        onReturnPressed,
        onConfirm,
        onConfirmCreate,
        closeModal,
        selectedCategories: selectedCategoriesData,
        yearlyAmount,
        coveragePercentage,
        allocationType,
        lifestyleGroupName,
        isModalOpen,
        isLoading: isLoadingData
    }
} 
